import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ObtenerNumeroMcpServersService {
  private readonly mcpServersUrl: string;

  constructor(private httpClient: HttpClient) {
    this.mcpServersUrl = environment.apiUrl + '/administrador/mcp-servers/total';
  }

  public __invoke(): Observable<number> {
    return this.httpClient.get<number>(this.mcpServersUrl);
  }
}
